import { render } from "./ChipSituationTrend.vue?vue&type=template&id=66cd805e&scoped=true&ts=true"
import script from "./ChipSituationTrend.vue?vue&type=script&lang=ts"
export * from "./ChipSituationTrend.vue?vue&type=script&lang=ts"

import "./ChipSituationTrend.vue?vue&type=style&index=0&id=66cd805e&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66cd805e"]])

export default __exports__